<!-- <a href="https://superiorsystems.in/apple" target="_blank" class="floating-coin">
    <div class="coin">
      <div class="front">
        <img src="assets/images/superior.png" alt="Logo">
      </div>
      <div class="back">
        <img src="assets/images/authorized.png" alt="Logo">
      </div>
    </div>
  </a>
   -->
   <div class="page-title-area">
    <img src="assets/images/apple_ent.png" alt="Page Background" class="page-bg">
    <button class="back-arrow-btn" (click)="navigateToHome()">
        <i class="fas fa-chevron-left fa-2x"></i>
    </button>
    <div class="container">
        <div class="page-title-content">
            <h2>Apple Device for Enterprise</h2>
        </div>
    </div>
</div>

<section class="services-details-area pb-100">
    <div class="scrives-item-2 mt-5">
            <h2 style="padding-left: 50px; text-align: center;">Device for Enterprise</h2>
            <br>
            <div class="contact-container">
                <div class="form-box">
                    <div class="form-left">
                        <div class="cards-wrapper">
                            <button class="scroll-btn left" (click)="scrollCards('left')">
                                <i class="fas fa-chevron-left"></i>
                            </button>
                            <div class="cards-container" #cardsContainer
                                (mouseenter)="onMouseEnter()"
                                (mouseleave)="onMouseLeave()">
                                <div class="card" *ngFor="let card of cards; let i = index"
                                    [class.active]="i === activeIndex">
                                    <div class="card-icon">
                                        <i [class]="card.icon"></i>
                                    </div>
                                    <h1 style="font-size: 20px; font-weight: bold; text-align: center;">{{ card.title }}</h1>
                                    <p>{{ card.description }}</p>
                                </div>
                            </div>
                            <button class="scroll-btn right" (click)="scrollCards('right')">
                                <i class="fas fa-chevron-right"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</section>
<!-- <section class="animated-cards-section ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="animated-card slide-in" data-delay="0" style="background: linear-gradient(135deg, #1a237e, #0d47a1);">
                    <div class="card-content">
                        <div class="card-icon">
                            <i class="fas fa-users"></i>
                        </div>
                        <p>Empower your workforce with Apple devices, tailored for enterprise needs</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="animated-card slide-in" data-delay="800" style="background: linear-gradient(135deg, #01579b, #006064);">
                    <div class="card-content">
                        <div class="card-icon">
                            <i class="fas fa-laptop-code"></i>
                        </div>
                        <p>Get your team working smarter with Apple devices that just work.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="animated-card slide-in" data-delay="1600" style="background: linear-gradient(135deg, #007bff, #0056b3);">
                    <div class="card-content">
                        <div class="card-icon">
                            <i class="fas fa-cogs"></i>
                        </div>
                        <p>Deploy Macs and iPads at scale with zero-touch setup and enterprise-grade support.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->

<!-- <section class="services-details-area ptb-100">
    <div class="container">
        <div class="scrives-item-2 mt-4 ">
            <div class="row align-items-center">
                <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                    <div class="services-img mb-qc ios-content">
                        <div class="circular-layout">
                            <div class="image-container">
                              <img src="assets/images/networking1.jpeg" alt="image" class="image-container-img"/>
                            </div>
                          </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <p>Networking is essential for modern business infrastructure, enabling seamless communication and data exchange. Our approach starts with designing network cabling for efficient data flow and minimal interference. </p>
                    <p> We choose superior switches and strategic access points to optimise connectivity and reduce latency. </p>
                </div>
            </div>
        </div>

        <br>
        <br>

        <div class="scrives-item-2 mt-4 ">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <p> With expert installation, we ensure a strong, scalable network infrastructure customised to your needs. Our rigorous testing and certification processes confirm peak performance and compliance with industry standards. </p>
                    <p>We use advanced tools to monitor network health and address potential issues proactively. Our team is ready to support and guide you, ensuring reliable networks that meet evolving technological demands. </p>
                </div>

                <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                    <div class="services-img mb-qc ios-content">
                        <div class="circular-layout">
                            <div class="image-container">
                              <img src="assets/images/networking2.jpg" alt="image" class="image-container-img"/>
                            </div>
                          </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="scrives-item-2 mt-4 ">
            <div class="row align-items-center">
                <div class="col-lg-12">
                    <p> Connect with us to enhance your connectivity experience today!</p>
                </div>

            </div>
        </div>
    </div>
</section> -->

<div class="container mb-4">
    <div class="d-flex justify-content-end">
        <button class="btn back-btn" (click)="navigateToHome()">
            <i class="fas fa-arrow-left me-2"></i> Back to Home
        </button>
    </div>
</div>
<br>